import { InputType } from 'type-graphql'
import { QueryArgs } from '../../action'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

/** `filter.documentKind` and `filter.documentId` name the record; the rest of `filter` is the search. */
@InputType()
export class GetAttachableChatsArgs extends QueryArgs<Chat> {}

export interface IGetAttachableChats extends IAction<Chat[], GetAttachableChatsArgs> {}
